<template>
  <div class="">1111</div>
</template>
<script>
import { mixins1 } from "@/mixins/index";
import Page from "@/components/page/index.vue";

export default {
  mixins: [mixins1],
  components: {
    Page,
  },
  props: {
    isOpenSlct: {
      type: Boolean,
    },
    Compare: {
      type: Boolean,
    },
    FilterObj: {
      type: Object,
    },
  },
  watch: {
    FilterObj: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.$store.dispatch("app/setTools", {
            name: "riskScanning",
            key: "isActive",
            value: false,
          });
          this.$store.dispatch("app/setTools", {
            name: "customPortfolio",
            key: "isActive",
            value: false,
          });
          this.$store.dispatch("app/setTools", {
            name: "share",
            key: "isActive",
            value: false,
          });
          this.page.pageNo = 1;
        }

        // 这里可以进行一些逻辑处理或者触发其他操作
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    isOpenSlct: {
      handler(newVal, oldVal) {
        this.isOpenSlct = newVal;
        // 在这里处理columns属性的变化
        if (newVal == false) {
          this.compareList = [];
          this.$store.dispatch("app/setcollectList", []);
          this.$store.dispatch("app/setchangeList", this.compareList);
        }
        this.refresh++;

        // 这里可以进行一些逻辑处理或者触发其他操作
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    Compare: {
      handler(newVal, oldVal) {
        // this.Compare = newVal;
        //         if (this.Compare) {
        //   this.setToolsfalse()
        // } else {
        //   this.handleSelectionChange([])
        //   this.refresh++
        // }
        // 在这里处理columns属性的变化
        // if (newVal == false) {
        //   this.handleSelectionChange([])
        //     this.compareList=[]
        //     this.$store.dispatch("app/setcollectList", []);
        //     this.$store.dispatch("app/setchangeList",  this.compareList);
        // }
        // this.refresh++
        // 这里可以进行一些逻辑处理或者触发其他操作
      },

      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
  },
  data() {
    return {
      reLoginVis: false,
      addDialog: false,

      menuActive: 1,
      datePicker: [],
      CategoryVal: "",
      yourUsagelist: [],
      compareList: [],
      compareListParent: [],
      window: window,
      page: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
    };
  },
  beforeDestroy() {},
  destroyed() {},
  mounted() {},

  methods: {},
};
</script>
<style scoped>
.btn_blue {
  padding: 0.7142857142857143rem 1.4285714285714286rem;
  background: #1290c9;
  font-size: 1.2857142857142858rem;
  color: #ffffff;
  cursor: pointer;
}

.btn_blu {
  margin-right: 1.4285714285714286rem;
}

.btn_blue img {
  width: 1.2857142857142858rem;
  height: 1.2857142857142858rem;
  margin-right: 0.42857142857142855rem;
}

/deep/ .el-table th.el-table__cell {
  background-color: #f2f5f9 !important;
}
.jiange {
  color: #cccccc;
  margin: 0 1.4285714285714286rem;
  font-size: 1.285714285714286rem;
  /* font-size: 1.25em; */
}
.contclass {
  font-size: 1.285714285714286rem;
  color: #1290c9;
  font-style: normal;
}

/deep/ .el-table th.el-table__cell > .cell {
  font-family: "Arial Bold";
}
</style>
